import { Button } from '@heidi/design-system/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@heidi/design-system/tooltip';
import { Maximize2, Minimize2 } from 'lucide-react';
import { useIntl } from 'react-intl';

import type { JSX } from 'react';

export interface PromptExpandToggleProps {
  expanded: boolean;
  onToggle: () => void;
}

export const PromptExpandToggle = ({
  expanded,
  onToggle,
}: PromptExpandToggleProps): JSX.Element => {
  const intl = useIntl();
  const label = expanded
    ? intl.formatMessage({
        defaultMessage: 'Collapse prompt',
        id: 'LlYKDCiIDt',
        description: 'Collapse the expanded Work home prompt editor',
      })
    : intl.formatMessage({
        defaultMessage: 'Expand prompt',
        id: 'm0N56Fi7VJ',
        description: 'Expand an overflowing Work home prompt editor',
      });

  return (
    <div className="absolute end-3 top-3 z-30">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="md"
            iconOnly
            aria-label={label}
            aria-expanded={expanded}
            onClick={(event) => {
              event.stopPropagation();
              onToggle();
            }}
            className="rounded-lg bg-surface shadow-sm"
          >
            {expanded ? (
              <Minimize2 className="size-4" aria-hidden />
            ) : (
              <Maximize2 className="size-4" aria-hidden />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </div>
  );
};
